import { useTranslate } from "ra-core";

import { resetHomeViewSession, useHomeDefaultView } from "./homeView";
import { HomeViewSegments } from "./HomeViewToggle";

/**
 * «Vista de inicio por defecto» (Settings / Profile). Saved per user in the
 * react-admin store (localStorage), applied on the next load of the desktop
 * home and right away for this session.
 */
export const HomeViewSetting = () => {
  const translate = useTranslate();
  const [view, setView] = useHomeDefaultView();
  const label = translate("desk.home.setting.title");
  return (
    <div className="home-setting">
      <div className="min-w-0">
        <p className="home-setting__label">{label}</p>
        <p className="home-setting__hint">
          {translate("desk.home.setting.hint")}
        </p>
      </div>
      <HomeViewSegments
        value={view}
        label={label}
        onChange={(next) => {
          setView(next);
          resetHomeViewSession();
        }}
      />
    </div>
  );
};
